import { Directions, getInDirection } from "../../engine/space/directions";
import { gameData } from "../GameManager";
import { FloorTypes } from "./Map";

export const checkMovement = (direction: Directions, x: number, y: number) => {
  const point = getInDirection({ x, y }, direction);
  const tile =
    gameData.current.tiles[point.x + point.y * gameData.current.width];
  return tile.type === FloorTypes.EMPTY;
};
